import { render } from "./v-contact.vue?vue&type=template&id=034aec04"
import script from "./v-contact.vue?vue&type=script&lang=js"
export * from "./v-contact.vue?vue&type=script&lang=js"

import "./v-contact.vue?vue&type=style&index=0&id=034aec04&lang=css"
script.render = render

export default script